import { FC, useCallback } from "react";
import { FormControl, MenuItem, Select, Stack } from "@mui/material";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { setResourceDetailsCoverageRelatedData } from "@/store/resource-details/resourceDetailsSlice";
import {
  HighchartsChartType,
  highchartsChartTypeIcons,
} from "@/storybook/c8r-highcharts/common/components/HighchartsChartTypeSelect";
import { resourceDetailsCoverageChartTypeSelector } from "@/store/resource-details/selectors/coverage-data/options/resourceDetailsCoverageChartTypeSelector";

export const ResourceDetailsCoverageTabChartType: FC = () => {
  const dispatch = useAppDispatch();
  const chartType = useAppSelector(resourceDetailsCoverageChartTypeSelector);

  const chartTypeChangeHandler = useCallback(
    (event: any) => {
      const newChartType = event.target.value as HighchartsChartType;

      dispatch(
        setResourceDetailsCoverageRelatedData({
          chartType: newChartType,
        }),
      );
    },
    [dispatch],
  );

  if (!chartType) {
    return null;
  }

  return (
    <FormControl size="small" sx={{ minWidth: 60 }}>
      <Select
        MenuProps={{ disablePortal: true }}
        value={chartType}
        size="small"
        sx={selectStyles}
        onChange={chartTypeChangeHandler}
        renderValue={(type: HighchartsChartType) => (
          <Stack alignItems="center" height="inherit">
            {highchartsChartTypeIcons[type]}
          </Stack>
        )}
      >
        {Object.entries(highchartsChartTypeIcons).map(([type, Icon]) =>
          ["pie", "horizontal_stack_bar"].includes(type) ? null : (
            <MenuItem value={type} key={type}>
              {Icon}
            </MenuItem>
          ),
        )}
      </Select>
    </FormControl>
  );
};

const selectStyles = {
  bgcolor: "white",
  minWidth: 60,
  "& .MuiSelect-select": { p: 0.5 },
};
